<template>
  <div>
    
      <v-row style="margin-left:20px;margin-right:20px;">
        <v-col md="8"  style="margin-top:10px;margin-bottom:10px;">
          <v-card  height="100%" class="mx-auto">
            <v-card-title class="prfont fontst">My Cart({{len}})</v-card-title>
            <div v-for="i in prodata">
              <hr />
              <!-- <h4 style="color:black;"><strong>{{i.product.productname}}</strong></h4> -->
              <v-card-text>
                <v-row>
                  <v-col md="2">
                    <v-col md="12">
                    <v-card class="jj">
                    <v-img :src="'https://api.inguzsales.in/u/'+i.product.photos[0]" style="width:100%;height:100%;object-fit:cover;" />
                    </v-card>
                    </v-col>
                    
                   
                    <v-row>
                      <v-col md="2">
                        <span
                         class="by"
                        >
                          <strong  @click="minusCart(i)" style="font-size:26px;padding-left:10px;">-</strong>
                        </span>
                      </v-col>
                      <v-col md="5" style="padding-left:30px;">
                        <div class="card bu">
                          <input type="text" id="fname" name="fname" size="5" v-model="i.quantity" style="font-size:15px;padding-left:10px;padding-top:3px;" />
                        </div>
                      </v-col>
                      <v-col md="3">
                        <span
                        class="by"
                        >
                          <strong @click="UpdateCart(i)" style="font-size:20px;padding:7px;">+</strong>
                        </span>
                      </v-col>
                      
                    </v-row>
                    
                  </v-col>
                  <v-col md="9" style="padding-top:20px;">
                    <h3 style="color:black;">
                      <strong class="prfont fontsp">{{i.product.productname}}</strong>
                    </h3>
                    <br />
                    <h3 style="color:black;">
                      <strong class="prfont fontsp">{{i.product.description.slice(0,80)}}..</strong>
                    </h3>
                    <br />
                    <h3 style="color:black;">
                      <strong class="prfont fontsp">₹ {{i.product.price}}</strong>
                    </h3>
                    <br />
                    <v-layout>
                      <v-flex style="padding-top:6px;">
                        <span >
                          <h3 style="color:black;">
                            <strong class="prfont fontsp">SAVE FOR LATER</strong> &nbsp;&nbsp;
                            <strong @click="RemoveCart" class="prfont fontsp"><a style="color:black;">REMOVE</a></strong>
                          </h3>
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-col>
                </v-row>
               
              </v-card-text>
            </div>
          </v-card>
        </v-col>
        <v-col md="4" style="margin-top:10px;">
          <v-card class="mx-auto" >
            <v-card-title class="prfont fontst">Price Details</v-card-title>
            <v-row>
              <v-col md="6">
                <h3 style="padding-left:20px;" class="prfont fontst ">Price&nbsp;({{len}}&nbsp;items)</h3>
              </v-col>
              <v-col md="6">
                <h3 class="prfont fontst">₹&nbsp;{{subtotal}}</h3>
              
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6">
                <h3 style="padding-left:20px;" class="fontst prfont">Total Tax</h3>
              </v-col>
              <v-col md="6">
                <h3 class="fontst">₹&nbsp;{{tottax}}</h3>
               
              </v-col>
            </v-row>
              <v-row>
              <v-col md="6">
                <h3 style="padding-left:20px;" class="fontst prfont">Shipping Charges</h3>
              </v-col>
              <v-col md="6">
                <h3 class="fontst">{{shipp}}</h3>
              </v-col>
            </v-row>
            <hr />
            <v-row>
              <v-col md="6">
                <h3 style="padding-left:20px;" class="fontst prfont">Total Payable</h3>
              </v-col>
              <v-col md="6">
                <h3 class="fontst">₹&nbsp;{{total}}</h3>
              </v-col>
              <v-col md="8" style="text-align:right;">
                <router-link :to="'/About/' +this.id">
                  <v-btn color="orange darken-2" dark>Place Order</v-btn>
                </router-link>
              </v-col>
            </v-row>

            <v-card-text></v-card-text>
          </v-card>
        </v-col>
      </v-row>
    
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
import axios from "axios";

export default {
  props: ["id"],
  components: {
    StarRating
  },
  data() {
    return {
      len: "",
      shipp:"",
      prodata: [],
      total: "",
      subtotal: "",

      tottax: ""
    };
  },
  mounted: function() {
    this.getProduct();
    this.getProducts();
    this.UpdateCart();
  },
  methods: {
    getproducts() {
      axios({
        method: "GET",
        url: "/product/info?id=" + this.id
      }).then(Response => {
        // console.log(Response);
        this.prodata = Response.data.data;
        this.photos = Response.data.data.photos;

        var tempflag = [];
        for (var i = 0; i < this.photos.length; i++) {
          var tyimg = {
            src: "https://api.inguzsales.in/u/" + this.photos[i],
            // src: $Image_URL + this.regions[i].flag,
            id: this.photos[i]
          };
          tempflag.push(tyimg);
        }
        this.dataImages = tempflag;
      });
    },
       minusCart(i) {
      for (var j = 0; j < this.prodata.length; j++) {
        if (i._id == this.prodata[j]._id) {
          this.prodata[j].quantity--;
        }
      }
      var data = {};
      data["productid"] = i.product._id;
      data["quantity"] = i.quantity;
      axios({
        method: "POST",
        url: "/Cart/update/",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status == true) {
            this.getProduct();
            this.msg = response.data.msg;
            this.$dlg.alert(
              this.msg,
              () => {
               
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    },
    UpdateCart(i) {
      for (var j = 0; j < this.prodata.length; j++) {
        if (i._id == this.prodata[j]._id) {
          this.prodata[j].quantity++;
        }
      }
      var data = {};
      data["productid"] = i.product._id;
      data["quantity"] = i.quantity;
      axios({
        method: "POST",
        url: "/Cart/update/",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status == true) {
            this.getProduct();
            this.msg = response.data.msg;
            this.$dlg.alert(
              this.msg,
              () => {
                window.location.reload();
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    },

    RemoveCart() {
      var data = {};
      data["productid"] = this.id;

      axios({
        method: "POST",
        url: "/Cart/Remove/",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status == true) {
            this.getProduct();
            this.msg = response.data.msg;
            this.$dlg.alert(
              this.msg,
              () => {
                window.location.reload();
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    },
    getProduct() {
      axios({
        method: "GET",
        url: "/Cart/all/",

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        this.prodata = Response.data.cart;
        this.len = Response.data.cart.length;
        this.total =  Math.round(Response.data.total);
        this.subtotal = Math.round( Response.data.subtotal);
        this.tottax = Math.round(Response.data.totaltax);
        this.shipp= Math.round(Response.data.shippingcharge);
        // console.log(Response);
      });
    }
  }
};
</script>
<style scoped>
.prfont {
  font-family: "Montserrat";
}
.by{
      width: 28px;
    height: 28px;
    background: linear-gradient(#fff,#f9f9f9);
    display: inline-block;
    border: 1px solid #c2c2c2;
    cursor: pointer;
    font-size: 16px;
    border-radius: 50%;
    padding-top: 1px;
    line-height: 1;
}
.bu{
      width: 28px;
    height: 28px;
    background: linear-gradient(#fff,#f9f9f9);
    display: inline-block;
    border: 1px solid #c2c2c2;
    cursor: pointer;
    font-size: 16px;
   
    padding-top: 1px;
    line-height: 1;
}
.jj{
 
  height:107px;
  width:143px;
}
.fontsp{
  font-size: 14px;
}
</style>